import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isExist } from "cxa-utils";
import { InputField } from "../../FormField";

const Dependent = ({ data }) => {
  const spouseName = data["SpouseName"] || {};
  const spouseIdentification = data["SpouseIdentification"] || {};
  const spouseBirthDate = data["SpouseBirthDate"] || {};
  const marriageDate = data["MarriageDate"] || {};
  const spouseJobTitle = data["SpouseJobTitle"] || {};
  const spouseNationality = data["SpouseNationality"] || {};
  const spouseGender = data["SpouseGender"] || {};
  const spouseHeight = data["SpouseHeight"] || {};
  const spouseWeight = data["SpouseWeight"] || {};
  const spouseContactNumber = data["SpouseContactNumber"] || {};
  const spouseEmail = data["SpouseEmail"] || {};

  return (
    <fieldset>
      <h3>{"DEPENDENT'S INFORMATION (to complete only if spouse requires underwriting)"}</h3>
      <section className="basicinfo">
        <div>
          <label htmlFor="SpouseName">Name of Spouse (Full as shown in NRIC)</label>
          <div className="field-container" id="RO_SpouseName">
            <InputField name="SpouseName" {...spouseName} />
          </div>
        </div>
        <div style={{ width: 400 }}>
          <label htmlFor="SpouseIdentification">NRIC/Passport No.</label>
          <div className="field-container" id="RO_SpouseIdentification">
            <InputField name="SpouseIdentification" {...spouseIdentification} />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="SpouseBirthDate">Date of Birth</label>
          <div className="field-container" id="RO_SpouseBirthDate">
            <InputField
              name="SpouseBirthDate"
              format={value => isExist(value) && moment(value).format()}
              {...spouseBirthDate}
            />
          </div>
        </div>
        <div style={{ width: 250 }}>
          <label htmlFor="MarriageDate">Date of Marriage</label>
          <div className="field-container">
            <InputField name="MarriageDate" {...marriageDate} />
          </div>
        </div>
        <div style={{ width: 400 }}>
          <label htmlFor="SpouseJobTitle">Occupation</label>
          <div className="field-container">
            <InputField name="SpouseJobTitle" {...spouseJobTitle} />
          </div>
        </div>
        <div style={{ width: 200 }}>
          <label htmlFor="SpouseNationality">Nationality</label>
          <div className="field-container">
            <InputField name="SpouseNationality" {...spouseNationality} />
          </div>
        </div>
        <div style={{ width: 80 }}>
          <label htmlFor="SpouseGender">Sex</label>
          <div className="field-container" id="RO_SpouseGender">
            <InputField name="SpouseGender" {...spouseGender} />
          </div>
        </div>
        <div style={{ width: 90 }}>
          <label htmlFor="SpouseHeight">Height(m)</label>
          <div className="field-container">
            <InputField name="SpouseHeight" {...spouseHeight} />
          </div>
        </div>
        <div style={{ width: 90 }}>
          <label htmlFor="SpouseWeight">Weight(kg)</label>
          <div className="field-container">
            <InputField name="SpouseWeight" {...spouseWeight} />
          </div>
        </div>

        <div style={{ width: 350 }}>
          <label htmlFor="SpouseContactNumber">Contact No</label>
          <div className="field-container">
            <InputField name="SpouseContactNumber" {...spouseContactNumber} />
          </div>
        </div>

        <div style={{ width: 420 }}>
          <label htmlFor="SpouseEmail">Email Address</label>
          <div className="field-container">
            <InputField name="SpouseEmail" {...spouseEmail} />
          </div>
        </div>
      </section>
    </fieldset>
  );
};

Dependent.propTypes = {
  data: PropTypes.object,
};

export default Dependent;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/Dependent.js